import { __decorate, __metadata } from "tslib";
import { Component, Provide } from "vue-property-decorator";
import { UIComponent } from "../UIComponent";
import { LvDrawerLayoutSide } from "./model";
/**
 * Injection symbol provided by the LvDrawerLayout component
 */
export const SYM_LV_DRAWER_LAYOUT = Symbol("LvDrawerLayout");
export const COMPONENT_NAME = "LvDrawerLayout";
/**
 * A drawer layout component
 */
let LvDrawerLayout = class LvDrawerLayout extends UIComponent {
    constructor() {
        super(...arguments);
        /**
         * Whether the left side is open
         */
        this.isLeftOpen = true;
        /**
         * Whether the right side is open
         */
        this.isRightOpen = true;
    }
    get self() {
        return this;
    }
    /**
     * Open a side of the drawer layout.
     * <br>If no side is given, both will be opened.
     * @param side - The side to open
     */
    open(side) {
        switch (side) {
            case LvDrawerLayoutSide.Left:
                this.isLeftOpen = true;
                break;
            case LvDrawerLayoutSide.Right:
                this.isRightOpen = true;
                break;
            default:
                this.isLeftOpen = true;
                this.isRightOpen = true;
                break;
        }
    }
    /**
     * Close a side of the drawer layout.
     * <br>If no side is given, both will be closed.
     * @param side - The side to close
     */
    close(side) {
        switch (side) {
            case LvDrawerLayoutSide.Left:
                this.isLeftOpen = false;
                break;
            case LvDrawerLayoutSide.Right:
                this.isRightOpen = false;
                break;
            default:
                this.isLeftOpen = false;
                this.isRightOpen = false;
                break;
        }
    }
};
__decorate([
    Provide(SYM_LV_DRAWER_LAYOUT),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], LvDrawerLayout.prototype, "self", null);
LvDrawerLayout = __decorate([
    Component({
        name: COMPONENT_NAME,
    })
], LvDrawerLayout);
export default LvDrawerLayout;
//# sourceMappingURL=script.js.map